import { registerMockAPI } from '~/mocks/mockApis';

import { axiosInstance } from '~/services';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypeGetStocksQueryTypeResponse } from '~/types/stock.types';

const useGetStocksQueryType = () => {
  const endpoint = '/api-inventory/v1/third-parties/stocks/query-types';

  const getStocksQueryType = async () => {
    return axiosInstance
      .get<TypeGetStocksQueryTypeResponse>(endpoint)
      .then((data) => {
        return data.data;
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { getStocksQueryType };
};

export default useGetStocksQueryType;

const stocksQueryTypesResponse: TypeGetStocksQueryTypeResponse = {
  data: {
    keyWord: [
      { code: 'SKU_CODE', name: 'SKU코드' },
      { code: 'SKU_NAME', name: '상품명' },
      { code: 'ALTER_CODE', name: '상품 바코드' },
    ],
    thirdPartyClusterType: [
      { code: 'ALL', name: '전체' },
      { code: 'CC02', name: '김포' },
      { code: 'CC03', name: '평택' },
    ],
    stockType: [
      { code: 'ALL', name: '전체' },
      { code: 'AVAILABLE', name: '가용' },
      { code: 'DEFECTIVE', name: '불용' },
    ],
    temperatureType: [
      { code: 'ALL', name: '전체' },
      { code: 'ROOM', name: '상온' },
      { code: 'COLD', name: '냉장' },
      { code: 'FROZEN', name: '냉동' },
    ],
  },
};

registerMockAPI<TypeGetStocksQueryTypeResponse>({
  method: 'get',
  endpoint: '/api-inventory/v1/third-parties/stocks/query-types',
  label: ['재고/상품별조회/필터옵션', '재고/유통기한별조회/필터옵션'],
  scenarios: [{ name: '정상 응답', response: stocksQueryTypesResponse }],
});
